/**
 * Splits a product category's comma-separated `breadcrumbs` (L1 through the leaf category)
 * into ordered levels, trimming whitespace and dropping empty segments.
 *
 * @example
 * parseCategoryBreadcrumbs('Health & Personal Care,Household Supplies,Facial Tissues')
 * // => ['Health & Personal Care', 'Household Supplies', 'Facial Tissues']
 */
export const parseCategoryBreadcrumbs = (breadcrumbs: string | null | undefined): string[] =>
  (breadcrumbs ?? '')
    .split(',')
    .map((level) => level.trim())
    .filter(Boolean);
